import { createFrozenSelector } from '../../utils/createFrozenSelector';
export const getRouterStateSlice = ({
  routerState
}) => routerState;
export const getCurrentObjectTypeId = createFrozenSelector([getRouterStateSlice], ({
  currentObjectTypeId
}) => currentObjectTypeId);